<template >
     <div v-if="scope.row[config.prop]!=undefined">
       {{scope.row[config.prop]}}
    </div>
    <div v-else>
      无对应字段~
    </div>
</template>

<script>
import { PIC_API as picAPI } from '@/utils/common';

export default {
    name:'TWord',
    cName:'文本',
    // functional: true,
    // Props 是可选的
    props: [ 'scope',
      'config',],
    data(){
      return {
        picAPI
      }
    }
     
    
};
</script>
